export default __webpack_public_path__ + "static/media/story-SLIDE_7.c2548221.jpg";